import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const HighlightOffIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"highlight_off"} ref={ref}/>
});

HighlightOffIcon.displayName = "HighlightOffIcon";
